import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs';
import { AppService } from '../shared/services/app.service';
import { BaseService } from '../shared/services/base.service';
@Pipe({
    name: 'documentName',
    standalone: false
})
export class DocumentPipe implements PipeTransform {
  val: any = false;
  constructor(public appService: AppService, private baseService: BaseService) { }
  transform(val, item?: any, field?: any): any {
    let subject = new Subject<string>();
    // return 'dataToPass';
    let query_id = '';
    if (field.datasource && field.datasource.query_id != undefined) {
      query_id = field.datasource.query_id
    } else {
      query_id = item[field.name];
    }
    let dataToPass: any;
    this.baseService.get(query_id, "", field.datasource.resource, field.datasource.application).subscribe(
      (data: any) => {
        if (data.errCode == 0) {
          this.val = data.documentName;
          dataToPass = data.documentName;
          subject.next(dataToPass);
        } else {
          dataToPass = '';
          subject.next(dataToPass);
        }
      }
    );
    return subject.asObservable();
  }
}
